module.exports = __webpack_public_path__ + "img/caro4.c05ad45d.png";